import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';

function Register() {
  const navigate = useNavigate();
  const [industries, setIndustries] = useState([]);
  const [formData, setFormData] = useState({
    business_name: '',
    industry: '',
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    password: '',
    confirmPassword: '',
    website: '' // honeypot - gerçek kullanıcı görmez/doldurmaz, botlar genelde her alanı doldurur
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  // Bot koruması: form ne zaman açıldı - script'in sayfayı okumadan anında
  // göndermesini yakalamak için (backend'de MIN_FORM_FILL_MS ile karşılaştırılır).
  const [formLoadedAt] = useState(() => Date.now());

  useEffect(() => {
    axios.get('/api/auth/industries')
      .then(res => {
        setIndustries(Array.isArray(res.data) ? res.data : []);
      })
      .catch(err => console.error('Sektörler yüklenemedi:', err));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (formData.password !== formData.confirmPassword) {
      setError('Şifreler eşleşmiyor');
      return;
    }

    if (!formData.industry) {
      setError('Lütfen bir sektör seçin');
      return;
    }

    setLoading(true);

    try {
      await axios.post('/api/auth/register-request', {
        business_name: formData.business_name,
        industry: formData.industry,
        first_name: formData.first_name,
        last_name: formData.last_name,
        email: formData.email,
        phone: formData.phone,
        password: formData.password,
        website: formData.website,
        form_loaded_at: formLoadedAt
      });
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Başvuru başarısız');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="login-page">
        <div className="login-decoration">
          <div className="decoration-circle circle-1"></div>
          <div className="decoration-circle circle-2"></div>
        </div>
        <div className="login-container">
          <div className="success-card">
            <div className="success-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h2>Başvurunuz Alındı</h2>
            <p>Başvurunuz incelenmek üzere admin'e gönderildi. Onaylandıktan sonra giriş yapabilirsiniz.</p>
            <Link to="/login" className="btn btn-primary">Giriş Sayfasına Dön</Link>
          </div>
        </div>
        <style>{`
          .login-page { min-height: 100vh; display: flex; align-items: center; justify-content: center; background: #0f172a; position: relative; overflow: hidden; }
          .login-decoration { position: absolute; inset: 0; overflow: hidden; }
          .decoration-circle { position: absolute; border-radius: 50%; filter: blur(80px); opacity: 0.5; }
          .circle-1 { width: 500px; height: 500px; background: var(--tertiary); top: -200px; right: -100px; }
          .circle-2 { width: 400px; height: 400px; background: #ec4899; bottom: -150px; left: -100px; }
          .login-container { background: white; border-radius: 24px; box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25); padding: 48px; width: 100%; max-width: 440px; position: relative; z-index: 10; }
          .success-card { text-align: center; }
          .success-icon { width: 80px; height: 80px; background: linear-gradient(135deg, #10b981, #059669); border-radius: 50%; display: flex; align-items: center; justify-content: center; margin: 0 auto 24px; }
          .success-icon svg { width: 40px; height: 40px; color: white; }
          .success-card h2 { font-size: 24px; color: #1e293b; margin: 0 0 12px; }
          .success-card p { color: #64748b; margin: 0 0 24px; }
          .btn { display: inline-flex; align-items: center; justify-content: center; gap: 8px; padding: 12px 24px; border-radius: 12px; font-weight: 600; cursor: pointer; transition: all 0.2s; text-decoration: none; border: none; }
          .btn-primary { background: linear-gradient(135deg, var(--tertiary), var(--secondary)); color: white; }
        `}</style>
      </div>
    );
  }

  return (
    <div className="login-page">
      <div className="login-decoration">
        <div className="decoration-circle circle-1"></div>
        <div className="decoration-circle circle-2"></div>
        <div className="decoration-circle circle-3"></div>
      </div>
      
      <div className="login-container">
        <div className="login-header">
          <div className="login-logo">
            <div className="logo-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
              </svg>
            </div>
            <h1 className="login-title">Kayıt Ol</h1>
          </div>
          <p className="login-subtitle">İşletmenizi kaydedin</p>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          {/* Honeypot - gerçek kullanıcılara görünmez (ekran okuyucular için de
              gizli), botlar formu tarayıp genelde bunu da doldurur. */}
          <input
            type="text"
            name="website"
            value={formData.website}
            onChange={(e) => setFormData({ ...formData, website: e.target.value })}
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            style={{ position: 'absolute', left: '-9999px', width: '1px', height: '1px', opacity: 0 }}
          />
          {error && (
            <div className="login-error">
              <svg viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
              </svg>
              {error}
            </div>
          )}

          <div className="form-group">
            <label className="form-label">İşletme Adı *</label>
            <input
              type="text"
              className="input"
              value={formData.business_name}
              onChange={(e) => setFormData({ ...formData, business_name: e.target.value })}
              placeholder="Örn: Güzellik Salonum"
              required
            />
          </div>

          <div className="form-group">
            <label className="form-label">Sektör *</label>
              <select
                className="select"
                value={formData.industry}
                onChange={(e) => setFormData({ ...formData, industry: e.target.value })}
                required
              >
                <option value="">Sektör seçin</option>
                {industries.map(ind => (
                  <option key={ind.slug} value={ind.slug}>
                    {ind.display_name}
                  </option>
                ))}
              </select>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label className="form-label">Ad *</label>
              <input
                type="text"
                className="input"
                value={formData.first_name}
                onChange={(e) => setFormData({ ...formData, first_name: e.target.value })}
                placeholder="Adınız"
                required
              />
            </div>
            <div className="form-group">
              <label className="form-label">Soyad *</label>
              <input
                type="text"
                className="input"
                value={formData.last_name}
                onChange={(e) => setFormData({ ...formData, last_name: e.target.value })}
                placeholder="Soyadınız"
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">E-posta *</label>
            <input
              type="email"
              className="input"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              placeholder="email@ornek.com"
              required
            />
          </div>

          <div className="form-group">
            <label className="form-label">Telefon</label>
            <input
              type="tel"
              className="input"
              value={formData.phone}
              onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
              placeholder="0532 123 4567"
            />
          </div>

          <div className="form-group">
            <label className="form-label">Şifre *</label>
            <input
              type="password"
              className="input"
              value={formData.password}
              onChange={(e) => setFormData({ ...formData, password: e.target.value })}
              placeholder="Şifreniz"
              required
              minLength={6}
            />
          </div>

          <div className="form-group">
            <label className="form-label">Şifre Tekrar *</label>
            <input
              type="password"
              className="input"
              value={formData.confirmPassword}
              onChange={(e) => setFormData({ ...formData, confirmPassword: e.target.value })}
              placeholder="Şifrenizi tekrar girin"
              required
            />
          </div>

          <button type="submit" className="btn btn-primary btn-lg w-full" disabled={loading}>
            {loading ? (
              <span className="loading-spinner"></span>
            ) : 'Başvuru Yap'}
          </button>
        </form>

        <div className="login-footer">
          <Link to="/login" className="register-link">Giriş sayfasına dön</Link>
        </div>
      </div>

      <style>{`
        .login-page { min-height: 100vh; display: flex; align-items: center; justify-content: center; background: #070b13; position: relative; overflow: hidden; }
        .login-decoration { position: absolute; inset: 0; overflow: hidden; }
        .decoration-circle { position: absolute; border-radius: 50%; filter: blur(80px); opacity: 0.35; }
        .circle-1 { width: 500px; height: 500px; background: var(--login-accent-light); top: -200px; right: -100px; animation: float 8s ease-in-out infinite; }
        .circle-2 { width: 400px; height: 400px; background: #ec4899; bottom: -150px; left: -100px; animation: float 10s ease-in-out infinite reverse; }
        .circle-3 { width: 300px; height: 300px; background: #10b981; top: 50%; left: 50%; transform: translate(-50%, -50%); animation: pulse 6s ease-in-out infinite; }
        @keyframes float { 0%, 100% { transform: translate(0, 0); } 50% { transform: translate(30px, -30px); } }
        .login-container { 
          background: rgba(13, 18, 30, 0.45); 
          border: 1px solid rgba(255, 255, 255, 0.05);
          border-radius: 24px; 
          box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5), inset 0 1px 1px rgba(255, 255, 255, 0.1); 
          backdrop-filter: blur(30px) saturate(190%);
          padding: 48px; 
          width: 100%; 
          max-width: 520px; 
          position: relative; 
          z-index: 10; 
          transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
        }
        .login-container:hover {
          border-color: rgba(255, 255, 255, 0.1);
          box-shadow: 0 30px 60px rgba(0, 0, 0, 0.6), inset 0 1px 1px rgba(255, 255, 255, 0.15);
        }
        .login-header { text-align: center; margin-bottom: 32px; }
        .login-logo { display: flex; flex-direction: column; align-items: center; gap: 12px; }
        .logo-icon { width: 56px; height: 56px; background: linear-gradient(135deg, var(--login-accent-light) 0%, var(--login-accent-dark) 100%); border-radius: 16px; display: flex; align-items: center; justify-content: center; }
        .logo-icon svg { width: 28px; height: 28px; color: white; }
        .login-title { font-size: 28px; font-weight: 700; color: #ffffff; letter-spacing: -0.5px; margin: 0; }
        .login-subtitle { color: #9ca3af; font-size: 14px; margin-top: 8px; }
        .login-form { display: flex; flex-direction: column; gap: 16px; }
        .form-group { display: flex; flex-direction: column; gap: 6px; }
        .form-row { display: flex; gap: 12px; }
        .form-row .form-group { flex: 1; }
        .form-label { font-weight: 600; color: #d1d5db; font-size: 13px; letter-spacing: 0.3px; }
        .input, .select { 
          padding: 12px 16px; 
          background: rgba(17, 24, 39, 0.6); 
          border: 1px solid rgba(255, 255, 255, 0.08); 
          color: #ffffff;
          border-radius: 12px; 
          font-size: 15px; 
          transition: all 0.2s; 
        }
        .input::placeholder { color: #6b7280; }
        .input:focus, .select:focus { 
          outline: none; 
          border-color: var(--login-accent-light); 
          background: rgba(17, 24, 39, 0.9);
          box-shadow: 0 0 0 3px rgba(var(--login-accent-light-rgb), 0.2); 
        }
        .select option { background: #0f172a; color: #ffffff; }
        .login-error { display: flex; align-items: center; gap: 10px; padding: 12px 16px; background: rgba(239, 68, 68, 0.08); border: 1px solid rgba(239, 68, 68, 0.2); border-radius: 12px; color: #fca5a5; font-size: 14px; }
        .login-error svg { width: 20px; height: 20px; flex-shrink: 0; color: #f87171; }
        .btn { display: inline-flex; align-items: center; justify-content: center; gap: 8px; padding: 14px 24px; border-radius: 12px; font-weight: 600; cursor: pointer; transition: all 0.2s; border: none; }
        .btn-lg { width: 100%; font-size: 15px; }
        .btn-primary { background: linear-gradient(135deg, var(--login-accent), var(--login-accent-dark)); color: white; }
        .btn-primary:hover { transform: translateY(-1px); box-shadow: 0 4px 12px rgba(var(--login-accent-rgb), 0.3); }
        .btn-primary:disabled { opacity: 0.7; cursor: not-allowed; }
        .loading-spinner { width: 20px; height: 20px; border: 2px solid rgba(255,255,255,0.3); border-top-color: white; border-radius: 50%; animation: spin 0.8s linear infinite; }
        @keyframes spin { to { transform: rotate(360deg); } }
        .login-footer { margin-top: 24px; padding-top: 24px; border-top: 1px solid rgba(255, 255, 255, 0.06); text-align: center; }
        .register-link { display: block; color: var(--login-accent-light); font-size: 14px; font-weight: 500; text-decoration: none; }
        .register-link:hover { text-decoration: underline; }
      `}</style>
    </div>
  );
}

export default Register;
